import { render, staticRenderFns } from "./thematicAreaReportCO.vue?vue&type=template&id=14bf4b98&scoped=true"
import script from "./thematicAreaReportCO.vue?vue&type=script&lang=js"
export * from "./thematicAreaReportCO.vue?vue&type=script&lang=js"
import style0 from "./thematicAreaReportCO.vue?vue&type=style&index=0&id=14bf4b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bf4b98",
  null
  
)

export default component.exports